import { config } from 'api';

export const DYNAMIC_YIELD_BETA_FEATURE = 'DYNAMIC_YIELD';

export const DY_JUST_LOGGED_IN_DATA_URL = `${config.apiBasePath}/dy/just-logged-in`;

export const DY_COOKIE_NAME = '_dyid';
export const DY_SESSION_COOKIE_NAME = '_dyjsession';

export const DY_RETRY_TIMEOUT = 1000;

export const PageContextType = {
  CATEGORY: 'CATEGORY',
  PRODUCT: 'PRODUCT',
  OTHER: 'OTHER',
};

export const EventTypes = {
  addToCart: {
    name: 'Add to Cart',
    type: 'add-to-cart-v1',
  },
  removeFromCart: {
    name: 'Remove from Cart',
    type: 'remove-from-cart-v1',
  },
  syncCart: {
    name: 'Sync Cart',
    type: 'sync-cart-v1',
  },
  purchase: {
    name: 'Purchase',
    type: 'purchase-v1',
  },
  addedOnCheckout: {
    name: 'Edited order additions',
  },
  removedFromCheckout: {
    name: 'Edited order removal',
  },
  login: {
    name: 'Login',
    type: 'login-v1',
  },
};
